import { createContext, useContext } from "react"

export type SidebarDefault = "open" | "closed"

interface LayoutShell {
  /** Header hosts that page header content is portalled into. */
  leftSlot: HTMLElement | null
  rightSlot: HTMLElement | null
  /** Applies a page's preferred sidebar state, honouring tour locks. */
  applySidebarDefault: (state: SidebarDefault) => void
}

/** Provided by the app shell, the outermost `Layout`. A `Layout` rendered
 *  inside it fills the shell's header instead of mounting a second shell. */
export const LayoutShellContext = createContext<LayoutShell | null>(null)

export const useLayoutShell = () => useContext(LayoutShellContext)
